module.exports = __webpack_public_path__ + "static/media/Banner-Home-Mobile.467f3aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/Banner-Home-Mobile.png
// module id = 259
// module chunks = 0